module.exports = __webpack_public_path__ + "images/Card_Test.png";